/**
 * 扫描接口可能返回的「整段一键改写」字段（不同服务命名不一致，在此归一）。
 */
export function pickScanFullRewriteText(raw: unknown): string | undefined {
  if (!raw || typeof raw !== "object") return undefined;
  const o = raw as Record<string, unknown>;
  for (const k of [
    "full_rewrite_text",
    "fullRewriteText",
    "rewrite_text",
    "rewriteText",
  ]) {
    const v = o[k];
    if (typeof v === "string" && v.trim()) {
      return v.trim();
    }
  }
  return undefined;
}
